import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../common/component/Index";
import DEFINE, { PATHS, PRICE_MAKEUP } from "../../../../constants/Define";
import { message } from 'antd';
import { isEqual, cloneDeep } from 'lodash';
import * as Func from '../../../../helpers/functions';
import Wrapper from './../../common/component/Wrapper';
import PriceMakeup from './../../modules/PriceMakeup';

import { FlightConfig } from '../../../../models/Flight';

import './PriceMakeupFlight.less';

let permisionActions = {};
const defaultState = {
    validation: {},
};

export default class PriceMakeupFlight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            flightConfig: cloneDeep(this.props.generalState.flightConfig)
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FLIGHT_PRICE_CONFIG);
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setFlightConfig(new FlightConfig())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.generalState.flightConfig && !isEqual(nextProps.generalState.flightConfig, this.props.generalState.flightConfig)) {
            this.setState({ flightConfig: cloneDeep(nextProps.generalState.flightConfig) });
        }
    }

    render() {
        const { t, generalState } = this.props;
        const { isFetching } = generalState;
        const { flightConfig, validation } = this.state;
        const value = flightConfig.type === PRICE_MAKEUP.TYPE.PERCENT ? flightConfig.percentPerTicker : flightConfig.feePerTicker
        const typeFieldName = flightConfig.type === PRICE_MAKEUP.TYPE.PERCENT ? 'percentPerTicker' : 'feePerTicker';
        return (
            <LoadingComponent spinning={isFetching}>
                <PageListComponent className="price-makeup-flight-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'priceMakeup'}
                        titleHeader={Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.price.title')}`.toLowerCase()))}

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={false}
                        action={'UPDATE'}
                        isGetItem={false}
                        submitButtonRight={true}
                        disableButtonBack={true}
                        disableButtonSubmit={!permisionActions.allowUpdate}
                    >
                        <Wrapper className='col-md-12 p-0 m-0'>
                            <PriceMakeup
                                disabled={!permisionActions.allowUpdate}
                                validation={validation}
                                showName={false}
                                value={value}
                                type={flightConfig.type}
                                startDate={flightConfig.startDate}
                                endDate={flightConfig.endDate}
                                onChangeValue={value => this.onChangeValue(typeFieldName, value)}
                                onChangeType={typeId => this.onChange('type', typeId)}
                                onChangeDate={this.onSelectDateRange}
                            />
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        this.props.getFlightConfig();
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            this.updateFlightConfig()
        }
    };

    validate() {
        const { t } = this.props;
        const { flightConfig } = this.state;
        let validate = {
            minValueNumber: {
                value: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.priceMakeup.title`)),
            },
            required: {
                startDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.priceMakeup.startDate`)),
            }
        };
        if (flightConfig.type === PRICE_MAKEUP.TYPE.AMOUNT) {
            flightConfig.value = flightConfig.feePerTicker;
        } else {
            flightConfig.value = flightConfig.percentPerTicker;
        }
        let valueValidate = {
            minValueNumber: { value: 0 }
        };
        const result = Func.multipleValidate(flightConfig, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onChange = (fieldName, value) => {
        const { flightConfig } = this.state;
        flightConfig[fieldName] = value;
        this.setState({ flightConfig })
    }

    onChangeValue = (fieldName, value) => {
        const newVal = value.replace(/,/g, "")
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(newVal) && reg.test(newVal)) || newVal === '' || newVal === '-') {
            this.onChange(fieldName, newVal);
        }
    }

    onSelectDateRange = (dateRangeArr = []) => {
        const { flightConfig } = this.state;
        flightConfig.startDate = dateRangeArr[0];
        flightConfig.endDate = dateRangeArr[1];
        this.setState({ flightConfig })
    }

    updateFlightConfig() {
        const { flightConfig } = this.state;
        this.props.updateFlightConfig(flightConfig)
    }

}
